// 复制迁移中控 吴程龙 代码
// 主要作用 因为localStorage主要为同步 所以需把indexDB大多数方法promise抛出同步方法
import Idb from 'assets/js/Idb';
import DBConfig from 'utils/indexDB/db-config';

/*
 * tableName 表名
 * data 数据
 * indexName 索引名称（可以理解成表头名称）
 * target 值
 * condition 条件
 * handle 处理结果
 * localStorageName 异常时储存的storageName
 * */

function connectDB() {
  // TODO static idb.js迁移oss loadScript加载
  return new Promise((resolve, reject) => {
    Idb(DBConfig)
      .then((db) => {
        window.hlyIndexDb = db;
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

function dbOrStorage(suc, fail) {
  if (window.hlyIndexDb) {
    suc();
  } else {
    connectDB()
      .then(() => {
        suc();
      })
      .catch(() => {
        fail();
      });
  }
}

export function clearTable({ tableName, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      localStorage.removeItem(localStorageName);
      window.hlyIndexDb.clear_table({ tableName });
      resolve();
    };
    const fail = () => {
      localStorage.removeItem(localStorageName);
      resolve();
    };
    dbOrStorage(suc, fail);
  });
}

export function insertDB({ tableName, data, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.insert({
        tableName,
        data,
        success: () => {
          resolve();
        },
      });
    };
    const fail = () => {
      let storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      if (!Array.isArray(storage)) {
        storage = Object.keys(storage).map((item) => {
          return {
            key: item,
            message: storage[item],
          };
        });
      }
      if (Array.isArray(data)) {
        storage = storage.concat(data);
      } else {
        storage.push(data);
      }
      localStorage.setItem(localStorageName, JSON.stringify(storage));
      resolve();
    };
    dbOrStorage(suc, fail);
  });
}

export function queryDB({ tableName, condition, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.query({
        tableName,
        condition,
        success: (res) => {
          resolve(res);
        },
      });
    };
    const fail = () => {
      const storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      resolve(storage.filter(condition));
    };
    dbOrStorage(suc, fail);
  });
}

export function updateDB({ tableName, condition, handle, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.update({
        tableName,
        condition,
        handle,
        success: (res) => {
          resolve(res);
        },
      });
    };
    const fail = () => {
      let storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      const temp = [];
      storage = storage.map((item) => {
        if (condition(item)) {
          item = handle(item);
          temp.push(item);
        }
        return item;
      });
      localStorage.setItem(localStorageName, JSON.stringify(storage));
      resolve(temp);
    };
    dbOrStorage(suc, fail);
  });
}

export function deleteDB({ tableName, condition, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.delete({
        tableName,
        condition,
        success: () => {
          resolve();
        },
      });
    };
    const fail = () => {
      let storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      storage = storage.filter((item) => !condition(item));
      localStorage.setItem(localStorageName, JSON.stringify(storage));
      resolve();
    };
    dbOrStorage(suc, fail);
  });
}

export function queryAllDB({ tableName, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.queryAll({
        tableName,
        success: (res) => {
          if (res.length === 0) {
            // 原来的localStorage塞入到indexDB
            let data = JSON.parse(localStorage.getItem(localStorageName) || '[]');
            if (!Array.isArray(data)) {
              data = Object.keys(data).map((item) => {
                return {
                  key: item,
                  message: data[item],
                };
              });
            }
            if (data.length) {
              window.hlyIndexDb.insert({
                tableName,
                data,
                success: () => {
                  localStorage.removeItem(localStorageName);
                  resolve(data);
                },
              });
            } else {
              resolve([]);
            }
          } else {
            resolve(res);
          }
        },
      });
    };
    const fail = () => {
      let storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      if (!Array.isArray(storage)) {
        storage = Object.keys(storage).map((item) => {
          return {
            key: item,
            message: storage[item],
          };
        });
      }
      resolve(storage);
    };
    dbOrStorage(suc, fail);
  });
}

// export function queryByKeyDB({ tableName, target, localStorageName }) {
//   return new Promise((resolve) => {
//     const suc = () => {
//       window.hlyIndexDb.query_by_primaryKey({
//         tableName,
//         target,
//         success: (res) => {
//           resolve(res);
//         },
//       });
//     };
//     const fail = () => {
//       const storage = JSON.parse(localStorage.getItem(localStorageName) || "[]");
//       const key = DBConfig.tables.find((table) => table.tableName === tableName)?.option?.keyPath;
//       const res = storage.find((item) => {
//         if (key) {
//           return item[key] === target;
//         }
//         return false;
//       });
//       resolve(res);
//     };
//     dbOrStorage(suc, fail);
//   });
// }

export function queryByIndexDB({ tableName, indexName, target, localStorageName }) {
  return new Promise((resolve) => {
    const suc = () => {
      window.hlyIndexDb.query_by_index({
        tableName,
        indexName,
        target,
        success: (res) => {
          resolve(res);
        },
      });
    };
    const fail = () => {
      const storage = JSON.parse(localStorage.getItem(localStorageName) || '[]');
      resolve(storage.filter((item) => item[indexName] === target));
    };
    dbOrStorage(suc, fail);
  });
}

// export function deleteByKeyDB({ tableName, target, localStorageName }) {
//   return new Promise((resolve) => {
//     const suc = () => {
//       window.hlyIndexDb.delete_by_primaryKey({
//         tableName,
//         target,
//         success: () => {
//           resolve();
//         },
//       });
//     };
//     const fail = () => {
//       let storage = JSON.parse(localStorage.getItem(localStorageName) || "[]");
//       const key = DBConfig.tables.find((table) => table.tableName === tableName)?.option?.keyPath;
//       if (key) {
//         storage = storage.filter((item) => item[key] !== target);
//         localStorage.setItem(localStorageName, JSON.stringify(storage));
//       }
//       resolve();
//     };
//     dbOrStorage(suc, fail);
//   });
// }

// export function updateByKeyDB({ tableName, target, handle, localStorageName }) {
//   return new Promise((resolve) => {
//     const suc = () => {
//       window.hlyIndexDb.update_by_primaryKey({
//         tableName,
//         target,
//         handle,
//         success: (res) => {
//           resolve(res);
//         },
//       });
//     };
//     const fail = () => {
//       let storage = JSON.parse(localStorage.getItem(localStorageName) || "[]");
//       const key = DBConfig.tables.find((table) => table.tableName === tableName)?.option?.keyPath;
//       const temp = [];
//       if (key) {
//         storage = storage.map((item) => {
//           if (item[key] === target) {
//             item = handle(item);
//             temp.push(item);
//           }
//           return item;
//         });
//         localStorage.setItem(localStorageName, JSON.stringify(storage));
//       }
//       resolve(temp);
//     };
//     dbOrStorage(suc, fail);
//   });
// }

export function generateRandomUUID() {
  const randomString = (length) => {
    let id = '';
    const chars = '0123456789abcdef';
    for (let i = 0; i < length; i++) {
      id += chars.charAt(Math.floor(Math.random() * 16));
    }
    return id;
  };
  return `${new Date().getTime()}-${randomString(32)}`;
}
